import type { SwitchTradeCommandData } from '@festina/unitlink-general-types/unitlink'
import { FormikForm } from '@festina-life/ui/formikForms'

import type { CommandDataFormProps } from '../../commandActions/CommandDataFormAndSimulation'
import { SwitchTradeFormFields } from './SwitchTradeFormFields'

export const SwitchTradeForm = ({
  onSubmit,
  ...props
}: CommandDataFormProps<SwitchTradeCommandData>) => {
  const initialValues: SwitchTradeCommandData = {
    _type: 'SwitchTradeCommandData',
  }

  const handleSubmit = async (switchTradeCommandData: SwitchTradeCommandData) =>
    await onSubmit({
      ...switchTradeCommandData,
      fundSelections:
        switchTradeCommandData.profileType === 'lifeCycleProfile'
          ? []
          : switchTradeCommandData.fundSelections,
    })

  return (
    <FormikForm
      initialValues={initialValues}
      onSubmit={handleSubmit}
      {...props}
    >
      {SwitchTradeFormFields}
    </FormikForm>
  )
}
